import useLeadPatientQualification from "../../../UseLeadPatientQualification";

/** A quick component wrapper to mount the legacy {@link useLeadPatientQualification} hook. */
const AppContextUseLeadPatientQualification: React.FC = () => {
  useLeadPatientQualification();
  return null;
};

export default AppContextUseLeadPatientQualification;
